import { Injectable } from '@angular/core';
import { Selector } from '@ngxs/store';
import { QuoteState, IQuoteState } from '@nibtravel/shared/data-access/quote';
import { PlansState, IPlanState } from '@nibtravel/shared/data-access/plans';
import {
  OptionType,
  IBasicOptionSummary,
  IPlanSummary,
  IBasicOptionInput,
} from '@nibtravel/shared/util/models';

@Injectable()
export class PmiOption {
  @Selector([QuoteState.planId, PlansState])
  public static pmiOption(
    planId: number | undefined,
    planState: IPlanState
  ): IBasicOptionSummary | undefined {
    if (planId && planState.planOptionsSummary) {
      const planOptions = planState.planOptionsSummary[planId];
      if (planOptions) {
        return planOptions.basicOptions.find(
          (opt) => opt.optionType === OptionType.PrivateMedicalInsurance
        );
      }
    }
  }

  @Selector([QuoteState])
  public static isOptedIn(quoteState: IQuoteState): boolean {
    const basicOptions = quoteState.input.basicOptions;
    const predicate = (option: IBasicOptionInput) =>
      option.optionType === OptionType.PrivateMedicalInsurance;
    const pmiInput = basicOptions ? basicOptions.find(predicate) : undefined;
    return pmiInput ? pmiInput.isOptedIn : false;
  }

  /** This seems to be a recurrent requirement. Need to think about a global facade. */
  @Selector([QuoteState.planId, PlansState.getPlanSummaries])
  static currencyCode(
    planId: number | undefined,
    planSummaries: Record<number, IPlanSummary> | undefined
  ): string {
    return planId && planSummaries
      ? planSummaries[planId]?.currencyCode
      : 'AUD';
  }
}
